import { INotification } from "@/types/INotification";
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface IState {
  notifications: INotification[];
}
let initialState: IState = {
  notifications: [],
};

export const NotificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setNotifications: (
      state,
      action: PayloadAction<{ nottifications: INotification[]; pageNo: number }>
    ) => {
      const ids = new Set(state.notifications.map((d) => d.notificationId));
      const filtered = action.payload.nottifications.filter(
        (d) => !ids.has(d.notificationId)
      );
      state.notifications =
        action.payload.pageNo === 0
          ? [...filtered , ...state.notifications]
          : [...state.notifications, ...filtered];
    },
    setSingleMarkAsRead: (state, action: PayloadAction<number>) => {
      const notificationId = action.payload;
      const notification = state.notifications.find(
        (n) => n.notificationId === notificationId
      );
      if (notification) {
        notification.isRead = 1; // Mark the notification as read
      }
    },
    setAllMarkAsRead: (state) => {
      state.notifications.forEach((notification) => {
        notification.isRead = 1; // Mark all notifications as read
      });
    },
  },
});

export const { setNotifications, setSingleMarkAsRead, setAllMarkAsRead } =
  NotificationsSlice.actions;

export default NotificationsSlice.reducer;
